import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ticket-priority-definition',
  templateUrl: './ticket-priority-definition.component.html',
  styleUrls: ['./ticket-priority-definition.component.css']
})
export class TicketPriorityDefinitionComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  ticketPriorityData: any = []
  allData: any = []
  singleTicketPriority: any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  id: any = ""
  recordName: any = ""
  recordId: any = ""
  searchKey: any = ""

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllTicketPriorityDefinition()
    
    this.form = this.fb.group({
      priorityStatus: ['', [Validators.required]],
      timeInHrs: ['', [Validators.required, Validators.min(0)]],
      description: [''],
    })
    
    this.editForm = this.fb.group({
      priorityStatus: ['', [Validators.required]],
      timeInHrs: ['', [Validators.required, Validators.min(0)]],
      description: [''],
    })
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllTicketPriorityDefinition();
  }
  
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllTicketPriorityDefinition();
  }

  addTicketPriority() {
    if (!this.form.valid) {
      this.toastr.error("please fill required fields");
      return
    }

    const priorityStatus = this.form.get('priorityStatus').value?.trim();
    const timeInHrs = this.form.get('timeInHrs').value;
    const description = this.form.get('description').value?.trim();

    if (!priorityStatus) {
      this.toastr.error("Priority Status is required");
      return;
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": description || '',
      "priorityStatus": priorityStatus,
      "timeInHrs": timeInHrs,
      "cid": this.cid
    }

    this.generic_service.addTicketPriorityDefinition(body).subscribe(
      (response: any) => {
        this.getAllTicketPriorityDefinition()
        this.cancelModel()
        this.form.reset()
        this.toastr.success(response.message || "Successfully Added")
      },
      (error: any) => {
        if(error?.error?.errors?.[0]?.description) {
            this.toastr.error(error.error.errors[0].description);
        } else {
            this.toastr.error("Error adding record");
        }
      }
    )
  }

  updateTicketPriority() {
    if (!this.editForm.valid) {
      this.toastr.error("please fill required fields");
      return
    }

    const priorityStatus = this.editForm.get('priorityStatus').value?.trim();
    const timeInHrs = this.editForm.get('timeInHrs').value;
    const description = this.editForm.get('description').value?.trim();

    let body = {
      ...this.singleTicketPriority[0],
      "description": description || '',
      "priorityStatus": priorityStatus,
      "timeInHrs": timeInHrs
    }

    this.generic_service.updateTicketPriorityDefinition(body).subscribe(
      (response: any) => {
        this.getAllTicketPriorityDefinition()
        this.cancelModel()
        this.editForm.reset()
        this.toastr.success(response.message || "Successfully Updated")
      },
      (error: any) => {
        if(error?.error?.errors?.[0]?.description) {
            this.toastr.error(error.error.errors[0].description);
        } else {
            this.toastr.error("Error updating record");
        }
      }
    )
  }

  formReset() {
    this.form.reset()
    this.editForm.reset()
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
  }

  getAllTicketPriorityDefinition() {
    this.isLoading = true

    this.generic_service.getAllTicketPriorityDefinition().subscribe(
      (res: any) => {
        this.allData = res.response || []
        this.ticketPriorityData = res.response || []
        this.count = this.ticketPriorityData.length
        this.isLoading = false
      },
      (err: any) => {
        console.log(err)
        this.isLoading = false
      }
    )
  }

  getTicketPriorityDefinitionById(id: any) {
    this.generic_service.getTicketPriorityDefinitionById(id).subscribe(
      (res: any) => {
        this.singleTicketPriority = []
        this.singleTicketPriority.push(res.response)
        this.editForm.patchValue({
          priorityStatus: res.response.priorityStatus,
          timeInHrs: res.response.timeInHrs,
          description: res.response.description,
        })
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  deleteTicketPriorityDefinition() {
    this.generic_service.deleteTicketPriorityDefinition(this.id).subscribe(
      (response: any) => {
        document.getElementById("deleteModalButton")?.click()
        this.toastr.success(response.message || "Successfully Deleted")
        this.getAllTicketPriorityDefinition()
        this.recordName = ""
        this.recordId = ""
      },
      (error: any) => {
        console.log(error)
        if(error?.error?.errors?.[0]?.description) {
            this.toastr.error(error.error.errors[0].description)
        } else {
            this.toastr.error("Error deleting record");
        }
      }
    )
  }

  selectDelete(id: any, record: any) {
    this.id = id;
    this.recordId = record.ticketPriorityDefinitionId;
    this.recordName = record.priorityStatus;
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }

  getAllByWildSearch() {
    if (this.searchKey == "" || this.searchKey == null) {
      this.ticketPriorityData = this.allData
      this.count = this.allData.length
      return
    }
    
    const key = this.searchKey.toLowerCase();
    this.ticketPriorityData = this.allData.filter((item: any) => 
        (item.priorityStatus && item.priorityStatus.toLowerCase().includes(key)) ||
        (item.description && item.description.toLowerCase().includes(key))
    );
    this.count = this.ticketPriorityData.length;
  }

  refreshAll() {
    this.page = 1
    this.first = 0
    this.searchKey = ""
    this.getAllTicketPriorityDefinition()
  }
}
